export const SITE = {
  url: process.env.REACT_APP_SITE_URL || 'https://vireo-renovation.fr',
  name: 'VIREO',
  legalName: 'VIREO Rénovation',
  phone: '+33185097125',
  phoneDisplay: '01 85 09 71 25',
  email: 'devis@vireo-renovation.fr',
  street: '29 rue Tronchet',
  postalCode: '75008',
  city: 'Paris',
  region: 'Île-de-France',
  areaServed: [
    'Paris',
    'Argenteuil',
    'Gennevilliers',
    'Asnières-sur-Seine',
    'Colombes',
    'Montreuil',
    'Pantin',
    'Pontoise',
    'Cergy',
  ],
  logo: 'https://customer-assets.emergentagent.com/job_facade-vireo/artifacts/isyxm6xn_VIREO_logo_compresse%CC%81.png',
  videoUrl:
    'https://customer-assets.emergentagent.com/job_facade-vireo/artifacts/b4ff8ecfe561a378_VIREO%20RE%CC%81NOVATION%20v1.mp4',
  videoPoster:
    'https://images.unsplash.com/photo-1614349214089-e969a07e033b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&h=900&fit=crop',
  whatsapp: '33623758508',
  whatsappMessage: 'Bonjour, je souhaite un devis gratuit pour mes travaux de rénovation / ravalement.',
};
